(function () {
  var root = document.querySelector('.ziggy-page');
  if (!root) return;

  var apiUrl = (root.dataset.apiUrl || '').replace(/\/$/, '');

  var emailInput = root.querySelector('#z-email');
  var loginBtn = root.querySelector('#z-login');
  var msg = root.querySelector('#z-msg');
  var gated = root.querySelector('#gated');

  var backdrop = root.querySelector('#z-request-backdrop');
  var closeBtn = root.querySelector('#z-request-close');
  var nameInput = root.querySelector('#z-request-name');
  var companyInput = root.querySelector('#z-request-company');
  var requestSubmitBtn = root.querySelector('#z-request-submit');
  var requestMsg = root.querySelector('#z-request-msg');

  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var pendingEmail = '';

  function setMsg(el, text, color) {
    el.style.color = color || '';
    el.textContent = text || '';
  }

  function openModal() {
    nameInput.value = '';
    companyInput.value = '';
    setMsg(requestMsg, '');
    requestSubmitBtn.disabled = false;
    requestSubmitBtn.textContent = 'Request access';
    backdrop.classList.add('show');
  }

  function closeModal() {
    backdrop.classList.remove('show');
  }

  function revealGated() {
    setMsg(msg, 'access granted. materials below.', '#4CC9F0');
    gated.classList.add('show');
    gated.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  loginBtn.addEventListener('click', function () {
    var email = (emailInput.value || '').trim().toLowerCase();
    if (!EMAIL_RE.test(email)) {
      setMsg(msg, 'enter a valid email', '#F72585');
      return;
    }
    if (!apiUrl) {
      console.error('Ziggy page: API URL is not configured');
      setMsg(msg, 'configuration error — try again later', '#F72585');
      return;
    }

    pendingEmail = email;
    loginBtn.disabled = true;
    setMsg(msg, 'verifying…', '#8A93B8');

    fetch(apiUrl + '/check-access', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    })
      .then(function (response) { return response.json(); })
      .then(function (result) {
        loginBtn.disabled = false;
        if (result && result.approved) {
          revealGated();
        } else {
          setMsg(msg, '');
          openModal();
        }
      })
      .catch(function (err) {
        console.error('Ziggy page: check-access failed', err);
        loginBtn.disabled = false;
        setMsg(msg, 'something went wrong — try again', '#F72585');
      });
  });

  emailInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') loginBtn.click();
  });

  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', function (e) {
    if (e.target === backdrop) closeModal();
  });

  requestSubmitBtn.addEventListener('click', function () {
    var name = (nameInput.value || '').trim();
    var company = (companyInput.value || '').trim();

    if (!name || !company) {
      setMsg(requestMsg, 'please fill in both fields', '#F72585');
      return;
    }
    if (!apiUrl) {
      setMsg(requestMsg, 'configuration error — try again later', '#F72585');
      return;
    }

    requestSubmitBtn.disabled = true;
    requestSubmitBtn.textContent = 'Sending…';
    setMsg(requestMsg, '');

    fetch(apiUrl + '/request-access', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: pendingEmail, name: name, company: company })
    })
      .then(function (response) { return response.json(); })
      .then(function (result) {
        if (result && result.status === 'already_approved') {
          closeModal();
          revealGated();
          return;
        }
        requestSubmitBtn.textContent = 'Request sent';
        setMsg(requestMsg, "we'll email you once it's reviewed.", '#4CC9F0');
      })
      .catch(function (err) {
        console.error('Ziggy page: request-access failed', err);
        requestSubmitBtn.disabled = false;
        requestSubmitBtn.textContent = 'Request access';
        setMsg(requestMsg, 'something went wrong — try again', '#F72585');
      });
  });
})();
